import styled from 'styled-components'
import { Card, Modal } from 'react-bootstrap'

export const ChartContainer = styled(Card)`
  background: linear-gradient(145deg, #2d3748 0%, #1a202c 100%);
  border: 1px solid rgba(102, 126, 234, 0.2);
  border-radius: 16px;
  height: 700px;
  min-height: 600px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;

  @media (max-width: 1200px) {
    height: 600px;
  }

  @media (max-width: 768px) {
    height: 500px;
  }

  &:hover {
    border-color: rgba(102, 126, 234, 0.4);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
  }
`

export const ChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`

export const ChartTitle = styled.h6`
  color: #ffffff;
  margin: 0;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const DashboardContainer = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  gap: 1rem;
  padding: 1rem;
  overflow: hidden;
`

export const ChartPanel = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: linear-gradient(145deg, #1a202c 0%, #0f1419 100%);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
  position: relative;
`

export const InsightsPanel = styled.div`
  width: 400px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(145deg, #1a202c 0%, #0f1419 100%);
  border-radius: 12px;
  border: 1px solid rgba(102, 126, 234, 0.3);
  overflow: hidden;

  @media (max-width: 1400px) {
    width: 350px;
  }

  @media (max-width: 1200px) {
    width: 320px;
  }
`

export const FlowContainer = styled.div`
  flex: 1;
  width: 100%;
  min-height: 0;
  background: transparent;
  position: relative;
  display: flex;
  flex-direction: column;

  /* Override ReactFlow cursor in lasso mode */
  &.lasso-mode .react-flow,
  &.lasso-mode .react-flow__pane,
  &.lasso-mode .react-flow__renderer {
    cursor: crosshair !important;
  }

  /* Ensure ReactFlow has dimensions */
  .react-flow {
    width: 100%;
    height: 100%;
    flex: 1;
  }
`

export const GenerateButton = styled.button`
  background: linear-gradient(45deg, #402563, #114ee0);
  border: none;
  padding: 0.5rem 1rem;
  font-weight: 500;
  transition: all 0.2s ease;
  border-radius: 0.375rem;
  color: #ffffff;
  cursor: pointer;
  font-size: 0.875rem;

  &:hover:not(:disabled) {
    background: linear-gradient(45deg, #4e2d7c, #1757e8);
    transform: translateY(-1px);
  }

  &:disabled {
    background: #343a40;
    opacity: 0.7;
    cursor: not-allowed;
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #ffffff;
  gap: 1rem;
`

export const ContentViewerModal = styled(Modal)`
  .modal-dialog {
    max-width: 90vw;
    margin: 1rem auto;
  }

  .modal-content {
    background: #212529;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: #ffffff;
  }

  .modal-header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .modal-body {
    max-height: 70vh;
    overflow-y: auto;
  }
`

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  padding: 1rem 0;
`

export const ContentItem = styled.div`
  background: linear-gradient(145deg, #2d3748 0%, #1a202c 100%);
  border: 1px solid rgba(102, 126, 234, 0.2);
  border-radius: 12px;
  padding: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);

  &:hover {
    border-color: rgba(102, 126, 234, 0.4);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  }
`

export const ContentImage = styled.img`
  width: 100%;
  height: 120px;
  object-fit: contain;
  border-radius: 0.25rem;
  margin-bottom: 0.5rem;
  background: #000000;
`

export const ContentInfo = styled.div`
  font-size: 0.875rem;

  .content-name {
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #ffffff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .content-details {
    color: #adb5bd;
    font-size: 0.75rem;
    margin-bottom: 0.5rem;
  }

  .annotation-status {
    display: inline-block;
    padding: 0.125rem 0.5rem;
    border-radius: 0.25rem;
    font-size: 0.7rem;
    font-weight: 500;
  }

  .annotated {
    background: rgba(40, 167, 69, 0.2);
    color: #28a745;
    border: 1px solid rgba(40, 167, 69, 0.3);
  }

  .unannotated {
    background: rgba(17, 78, 224, 0.2);
    color: #114ee0;
    border: 1px solid rgba(17, 78, 224, 0.3);
  }
`

export const ButtonOverlay = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  z-index: 1100;
  max-width: 80vw;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: flex-start;

  .button-row {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    flex-wrap: wrap;
  }

  .dropdown-toggle,
  .btn {
    font-size: 0.75rem !important;
    padding: 0.5rem 0.8rem !important;
    white-space: nowrap;
    backdrop-filter: blur(12px);
    background: linear-gradient(135deg, rgba(45, 55, 72, 0.95), rgba(33, 37, 41, 0.95)) !important;
    border: 1px solid rgba(255, 255, 255, 0.15) !important;
    color: #ffffff !important;
    border-radius: 0.5rem !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
    font-weight: 500 !important;
    letter-spacing: 0.025em;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
      transition: left 0.5s ease;
    }

    &:hover {
      background: linear-gradient(
        135deg,
        rgba(52, 58, 64, 0.95),
        rgba(45, 55, 72, 0.95)
      ) !important;
      border-color: rgba(255, 255, 255, 0.25) !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.15) !important;

      &::before {
        left: 100%;
      }
    }

    &:active {
      transform: translateY(0) !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
    }

    &.btn-warning {
      background: linear-gradient(
        135deg,
        rgba(251, 191, 36, 0.95),
        rgba(245, 158, 11, 0.95)
      ) !important;
      color: #1a1a1a !important;
      border-color: rgba(251, 191, 36, 0.4) !important;
      font-weight: 600 !important;

      &:hover {
        background: linear-gradient(
          135deg,
          rgba(251, 191, 36, 1),
          rgba(245, 158, 11, 1)
        ) !important;
        border-color: rgba(251, 191, 36, 0.6) !important;
        box-shadow: 0 6px 20px rgba(251, 191, 36, 0.3), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
      }
    }

    &.btn-outline-primary {
      background: linear-gradient(
        135deg,
        rgba(17, 78, 224, 0.25),
        rgba(29, 78, 216, 0.25)
      ) !important;
      color: #60a5fa !important;
      border-color: rgba(17, 78, 224, 0.4) !important;

      &:hover {
        background: linear-gradient(
          135deg,
          rgba(17, 78, 224, 0.4),
          rgba(29, 78, 216, 0.4)
        ) !important;
        color: #93c5fd !important;
        border-color: rgba(17, 78, 224, 0.6) !important;
        box-shadow: 0 6px 20px rgba(17, 78, 224, 0.25), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
      }
    }

    &.btn-outline-warning {
      background: linear-gradient(
        135deg,
        rgba(251, 191, 36, 0.25),
        rgba(245, 158, 11, 0.25)
      ) !important;
      color: #fbbf24 !important;
      border-color: rgba(251, 191, 36, 0.4) !important;

      &:hover {
        background: linear-gradient(
          135deg,
          rgba(251, 191, 36, 0.4),
          rgba(245, 158, 11, 0.4)
        ) !important;
        color: #fcd34d !important;
        border-color: rgba(251, 191, 36, 0.6) !important;
        box-shadow: 0 6px 20px rgba(251, 191, 36, 0.25), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
      }
    }

    &.btn-outline-danger {
      background: linear-gradient(
        135deg,
        rgba(220, 53, 69, 0.25),
        rgba(239, 68, 68, 0.25)
      ) !important;
      color: #f87171 !important;
      border-color: rgba(220, 53, 69, 0.4) !important;

      &:hover {
        background: linear-gradient(
          135deg,
          rgba(220, 53, 69, 0.4),
          rgba(239, 68, 68, 0.4)
        ) !important;
        color: #fca5a5 !important;
        border-color: rgba(220, 53, 69, 0.6) !important;
        box-shadow: 0 6px 20px rgba(220, 53, 69, 0.25), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
      }
    }
  }

  .selected-count {
    color: #fbbf24;
    font-size: 0.75rem;
    font-weight: 600;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.8), rgba(17, 24, 39, 0.8));
    padding: 0.4rem 0.8rem;
    border-radius: 0.5rem;
    backdrop-filter: blur(12px);
    border: 1px solid rgba(251, 191, 36, 0.3);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    letter-spacing: 0.025em;
  }

  .selected-count {
    color: #fbbf24;
    font-size: 0.75rem;
    font-weight: 500;
    background: rgba(0, 0, 0, 0.7);
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    backdrop-filter: blur(4px);
  }
`

export const Legend = styled.div<{ $expanded?: boolean }>`
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(0, 0, 0, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.5rem;
  padding: 0.75rem;
  font-size: 0.75rem;
  color: #ffffff;
  z-index: 10;
  ${(props) =>
    props.$expanded
      ? `
    max-width: 80vw;
    width: max-content;
    max-height: 300px;
  `
      : `
    max-width: 200px;
    max-height: 70vh;
  `}
  overflow-y: auto;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
  }
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.25rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const LegendItemsContainer = styled.div<{ $expanded?: boolean }>`
  ${(props) =>
    props.$expanded
      ? `
    display: grid;
    grid-template-columns: repeat(6, minmax(120px, 1fr));
    gap: 0.15rem 0.5rem;
    width: 100%;
    
    & > div {
      margin-bottom: 0;
      font-size: 0.7rem;
    }
  `
      : `
    display: block;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 4px;
    
    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.1);
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.3);
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(255, 255, 255, 0.5);
    }
  `}
`

export const LegendColor = styled.div<{ color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  margin-right: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
`

// Stats Card styled components
export const StatsCard = styled(Card)`
  background: #212529;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const StatsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`

export const StatsTitle = styled.h6`
  color: #ffffff;
  margin: 0;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const StatsContent = styled.div`
  padding: 1rem;
  color: #ffffff;
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const StatsSection = styled.div`
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SectionTitle = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
  margin-bottom: 1rem;

  @media (max-width: 1400px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
`

export const CompactStatItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 0.375rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
`

export const CompactStatLabel = styled.span`
  color: #adb5bd;
  font-size: 0.8rem;
  font-weight: 500;
`

export const CompactStatValue = styled.span`
  color: #ffffff;
  font-weight: 600;
  font-size: 0.9rem;
`

export const StatItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  &:last-child {
    border-bottom: none;
  }
`

export const StatLabel = styled.span`
  color: #adb5bd;
  font-size: 0.875rem;
`

export const StatValue = styled.span`
  color: #ffffff;
  font-weight: 600;
  font-size: 1rem;
`

export const StatBadge = styled.span<{
  variant?: 'success' | 'warning' | 'info' | 'danger'
}>`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;

  ${(props) => {
    switch (props.variant) {
      case 'success':
        return `
          background: rgba(40, 167, 69, 0.2);
          color: #28a745;
          border: 1px solid rgba(40, 167, 69, 0.3);
        `
      case 'warning':
        return `
          background: rgba(255, 193, 7, 0.2);
          color: #ffc107;
          border: 1px solid rgba(255, 193, 7, 0.3);
        `
      case 'info':
        return `
          background: rgba(17, 78, 224, 0.2);
          color: #114ee0;
          border: 1px solid rgba(17, 78, 224, 0.3);
        `
      case 'danger':
        return `
          background: rgba(220, 53, 69, 0.2);
          color: #dc3545;
          border: 1px solid rgba(220, 53, 69, 0.3);
        `
      default:
        return `
          background: rgba(108, 117, 125, 0.2);
          color: #6c757d;
          border: 1px solid rgba(108, 117, 125, 0.3);
        `
    }
  }}
`

export const ScrollableContainer = styled.div`
  max-height: 200px;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
`

export const VectorizationProgress = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 3rem;
  color: #ffffff;
  gap: 1.5rem;
  text-align: center;
`

export const ProgressTitle = styled.h5`
  color: #ffffff;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const ProgressBarContainer = styled.div`
  width: 100%;
  max-width: 500px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 0.5rem;
  height: 12px;
  overflow: hidden;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.3);
`

export const ProgressBarFill = styled.div<{ progress: number }>`
  height: 100%;
  width: ${(props) => props.progress}%;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 0.5rem;
  transition: width 0.3s ease;
  box-shadow: 0 0 10px rgba(102, 126, 234, 0.5);
`

export const ProgressStats = styled.div`
  display: flex;
  gap: 2rem;
  font-size: 0.9rem;
  color: #adb5bd;

  .stat {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    .label {
      font-size: 0.75rem;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }

    .value {
      font-size: 1.25rem;
      font-weight: 600;
      color: #ffffff;
    }
  }
`

export const HealthScoreContainer = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
`

export const StatusBar = styled.div<{ status: 'ready' | 'warning' | 'error' }>`
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: ${(props) => {
    if (props.status === 'ready') return 'rgba(40, 167, 69, 0.1)'
    if (props.status === 'warning') return 'rgba(255, 193, 7, 0.1)'
    return 'rgba(220, 53, 69, 0.1)'
  }};
  border-left: 3px solid
    ${(props) => {
      if (props.status === 'ready') return '#28a745'
      if (props.status === 'warning') return '#ffc107'
      return '#dc3545'
    }};
`

export const StatusDot = styled.div<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => props.color};
`

export const StatusText = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
  color: #ffffff;
  flex: 1;
`

export const IssueGroup = styled.div`
  margin-bottom: 1.5rem;
`

export const IssueGroupTitle = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #adb5bd;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const IssueList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const IssueItem = styled.div<{ clickable?: boolean }>`
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #ffffff;
  cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) =>
      props.clickable ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.03)'};
    border-color: ${(props) =>
      props.clickable ? 'rgba(102, 126, 234, 0.5)' : 'rgba(255, 255, 255, 0.1)'};
  }
`

export const PairRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
`

export const PairClasses = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
`

export const ClassBadge = styled.span<{ color?: string }>`
  padding: 0.25rem 0.5rem;
  background: ${(props) => (props.color ? `${props.color}20` : 'rgba(255, 255, 255, 0.1)')};
  border: 1px solid ${(props) => props.color || 'rgba(255, 255, 255, 0.2)'};
  border-radius: 3px;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
`

export const PairDistance = styled.div`
  font-size: 0.75rem;
  color: #adb5bd;
  white-space: nowrap;
`

export const SimpleBarChart = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  height: 60px;
  margin: 0.75rem 0;
`

export const SimpleBar = styled.div<{ height: number; color: string }>`
  flex: 1;
  height: ${(props) => props.height}%;
  background: ${(props) => props.color};
  border-radius: 4px 4px 0 0;
  position: relative;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.8;
    transform: translateY(-2px);
  }
`

export const BarLabel = styled.div`
  position: absolute;
  bottom: -20px;
  left: 0;
  right: 0;
  font-size: 0.65rem;
  text-align: center;
  color: #adb5bd;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const HealthScoreCircle = styled.div<{ score: number }>`
  width: 120px;
  height: 120px;
  margin: 0 auto 1rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: ${(props) => {
    if (props.score >= 80)
      return 'radial-gradient(circle, rgba(40, 167, 69, 0.2) 0%, rgba(40, 167, 69, 0.05) 100%)'
    if (props.score >= 60)
      return 'radial-gradient(circle, rgba(255, 193, 7, 0.2) 0%, rgba(255, 193, 7, 0.05) 100%)'
    return 'radial-gradient(circle, rgba(220, 53, 69, 0.2) 0%, rgba(220, 53, 69, 0.05) 100%)'
  }};
  border: 3px solid
    ${(props) => {
      if (props.score >= 80) return '#28a745'
      if (props.score >= 60) return '#ffc107'
      return '#dc3545'
    }};
  box-shadow: ${(props) => {
    if (props.score >= 80) return '0 0 20px rgba(40, 167, 69, 0.3)'
    if (props.score >= 60) return '0 0 20px rgba(255, 193, 7, 0.3)'
    return '0 0 20px rgba(220, 53, 69, 0.3)'
  }};
`

export const HealthScoreValue = styled.div<{ score: number }>`
  font-size: 2.5rem;
  font-weight: bold;
  color: ${(props) => {
    if (props.score >= 80) return '#28a745'
    if (props.score >= 60) return '#ffc107'
    return '#dc3545'
  }};
  line-height: 1;
`

export const HealthScoreLabel = styled.div`
  font-size: 0.75rem;
  color: #adb5bd;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 0.25rem;
`

export const InsightsScrollContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1rem;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(102, 126, 234, 0.3);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(102, 126, 234, 0.5);
  }
`

export const IssueSection = styled.div<{ severity?: 'critical' | 'warning' | 'good' }>`
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const IssueSectionHeader = styled.div<{ severity?: 'critical' | 'warning' | 'good' }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  background: ${(props) => {
    if (props.severity === 'critical') return 'rgba(220, 53, 69, 0.1)'
    if (props.severity === 'warning') return 'rgba(255, 193, 7, 0.1)'
    return 'rgba(40, 167, 69, 0.1)'
  }};
  border-left: 3px solid
    ${(props) => {
      if (props.severity === 'critical') return '#dc3545'
      if (props.severity === 'warning') return '#ffc107'
      return '#28a745'
    }};
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => {
      if (props.severity === 'critical') return 'rgba(220, 53, 69, 0.15)'
      if (props.severity === 'warning') return 'rgba(255, 193, 7, 0.15)'
      return 'rgba(40, 167, 69, 0.15)'
    }};
  }
`

export const IssueCard = styled.div<{ severity?: 'high' | 'medium' | 'low' }>`
  padding: 0.75rem;
  margin: 0.5rem 0;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 0.5rem;
  border-left: 3px solid
    ${(props) => {
      if (props.severity === 'high') return '#dc3545'
      if (props.severity === 'medium') return '#ffc107'
      return '#17a2b8'
    }};
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    transform: translateX(2px);
  }
`

export const ActionButton = styled.button<{ variant?: 'primary' | 'secondary' }>`
  background: ${(props) =>
    props.variant === 'primary'
      ? 'linear-gradient(45deg, #667eea, #764ba2)'
      : 'rgba(255, 255, 255, 0.1)'};
  border: 1px solid
    ${(props) =>
      props.variant === 'primary' ? 'rgba(102, 126, 234, 0.5)' : 'rgba(255, 255, 255, 0.2)'};
  color: #ffffff;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;

  &:hover {
    background: ${(props) =>
      props.variant === 'primary'
        ? 'linear-gradient(45deg, #7c8ef0, #8659b0)'
        : 'rgba(255, 255, 255, 0.15)'};
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`

export const TabsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;

  .nav-tabs {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    background-color: transparent;
    flex-shrink: 0;

    .nav-link {
      color: #adb5bd;
      border: none;
      border-bottom: 2px solid transparent;
      background-color: transparent;
      padding: 0.75rem 1.5rem;
      transition: all 0.2s ease;

      &:hover {
        color: #ffffff;
        background-color: rgba(255, 255, 255, 0.05);
        border-bottom-color: rgba(102, 126, 234, 0.5);
      }

      &.active {
        color: #ffffff;
        background-color: rgba(102, 126, 234, 0.1);
        border-bottom-color: #667eea;
        font-weight: 600;
      }
    }
  }

  .tab-content {
    flex: 1;
    overflow: hidden;
    min-height: 0;
    display: flex;
    flex-direction: column;

    .tab-pane {
      height: 100%;
      display: none;

      &.active {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
      }
    }
  }
`
